<template >
    <div class="centerPanelContainer">
        <slot name="content">content</slot>
    </div>
</template>
<script>
export default {
    name: 'centerPanel'
}
</script>